import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiHome, FiUsers, FiBriefcase, FiUserCheck, FiFileText, FiRss, FiUser, FiMessageSquare, FiLinkedin, FiTarget, FiBarChart2 } from "react-icons/fi";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";

const Sidebar = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const menuItems = [
    { to: "/admin/organizations", label: "Organizations", icon: HiOutlineBuildingOffice2 },
    { to: "/admin/users", label: "User", icon: FiUsers },
    { to: "/admin/candidates", label: "Candidates", icon: FiUser },
    { to: "/admin/jobs", label: "Jobs", icon: FiBriefcase },
    { to: "/admin/applications", label: "Applications", icon: FiFileText },
    { to: "/admin/channels", label: "Channels", icon: FiRss },
    { to: "/admin/conversations", label: "Conversations", icon: FiMessageSquare },
    { to: "/admin/chat", label: "Chat", icon: FiMessageSquare },
    { to: "/admin/linkedin-rotation", label: "LinkedIn Rotation", icon: FiLinkedin },
    { to: "/admin/qualification", label: "Qualification", icon: FiTarget },
    { to: "/admin/usage", label: "AI Usage", icon: FiBarChart2 },
  ];

  return (
    <>
      {/* Mobile menu button */}
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-white border border-gray-200 shadow-sm text-gray-600 hover:bg-gray-50"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
      >
        {isMobileOpen ? <HiX className="h-6 w-6" /> : <HiMenuAlt3 className="h-6 w-6" />}
      </button>

      {/* Mobile overlay */}
      {isMobileOpen && <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsMobileOpen(false)} />}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-full w-64 bg-white border-r border-gray-200 z-40 transform transition-transform duration-300 ease-in-out
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="h-16 flex flex-col justify-center px-6 border-b border-gray-200">
            <span className="text-xl font-extrabold text-gray-900">Jobego</span>
            <span className="text-xs text-gray-500 font-medium mt-0.5">Admin</span>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto py-4">
            <div className="px-3 space-y-1">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/admin"}
                    onClick={() => setIsMobileOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                        isActive ? "bg-purple-600 text-white" : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      }`
                    }
                  >
                    <Icon className="w-5 h-5 shrink-0" />
                    <span>{item.label}</span>
                  </NavLink>
                );
              })}
            </div>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
